import { 
    yellow,
    red,
    blue,
    axisName,
    pageBg
} from './color'

export var getDoubleAxis = function(startValue=-30){
  return { 
    type: 'both',
    left: 40, // {string|number} 左
    right: 40, // {string|number} 右
    bottom: 30, 
    seriesIndex: 0,
    minValueSpan: 10,
    startValue: startValue,
    // 填充块配置
    filler: {
        style: {
            fill: 'rgba(116,120,126,0.2)',
            stroke: 'rgba(116,120,126,0.2)'
        }
    },
    handler: {
        show: true, // 是否显示手柄
        style: { // {Object} 样式
            fill: '#74787E'
        }
    },
    dataBackground: {
      show: true,
      // 折线配置
      line: {
          show: true, // {boolean} 是否以折线显示
          style: { // {Object} 样式
              stroke: 'rgba(47,69,84,0.3)',
              lineWidth: 0.5
          }
      },
      // 区域配置
      area: {
          show: true, // {boolean} 是否以区域显示
          style: { // {Object} 样式
              fill: '#25262A'
              // fill: 'rgba(45,47,52,0.8)'
          }
      }
    },
    // 背景设置
    background: {
      show: true, // {boolean} 是否显示背景
      style: { // {Object} 样式
          fill: 'rgba(28,29,33,0.1)',
          stroke: '#2D2F34'
      }
    }
  }
}

export var getSingleAxis = function(opt){
  var datazoom2 = getDoubleAxis(opt);
  datazoom2.right = 4;
  return datazoom2;
}